<template>
    <div>
      <common-list
        ref="list"
        url="VehicleParts/GetList"
        @currentrow="handlerCurrentRow"
      >
        <!-- 条件区域 -->
        <template v-slot:filter="{ filter }">
          <el-col :span="6">
          <el-form-item label="配件名称" prop="PartsName">
            <el-input
              v-model.trim="filter.PartsName"
              placeholder="配件名称" 
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        </template>
        <!-- 按钮区域 -->
        <template v-slot:option>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="add"
            v-if="auth('VehiclePartsAdd')"
            >添加</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click="edit"
            v-if="auth('VehiclePartsEdit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('VehiclePartsDelete')"
            >删除</el-button
          >
          <el-button 
            type="blue" 
            icon="el-icon-tickets" 
            @click="show"
            v-if="auth('VehiclePartsShow')"
            >查看</el-button
          >
        </template>
        <!-- 展示区域 -->
        <template v-slot:body>
          <!-- <el-table-column
            label="机构名称"
            prop="CompanyName"
           
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="配件编号"
            prop="PartsId"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="配件名称"
            prop="PartsName"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="所属机构"
            prop="CompanyName"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column label="单位" 
            prop="Unit" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建日期" 
            prop="CreateTime" 
            show-overflow-tooltip>
          </el-table-column>
        </template>
      </common-list>
      <!-- 弹窗区域 Show -->
      <div>
        <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
        <Showdialog :item="itemShow"></Showdialog>
      </div>
    </div>
  </template>
  
  <script>
  import AddEdit from "./AddEdit";
  import Showdialog from "./Show";
  export default {
    components: {
        AddEdit,
        Showdialog
    },
    data() {
      return {
        itemAddEdit: {},
        itemShow:{},
        showitem: [],
      };
    },
    computed: {

    },
    mounted() {
     
    },
    methods: {
      getData() {
        this.$refs.list.getTableData();
      },
      add() {
        this.itemAddEdit = {};
      },
      edit() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemAddEdit = { PartsId: this.currentrow.PartsId };
      },
      deleteItem() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.$confirm(
          `将删除配件名称为【${this.currentrow.PartsName}】的配件信息, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            this.$delete("VehicleParts/Delete", {
              PartsId: this.currentrow.PartsId,
            }).then(() => {
              this.$message.success("删除成功");
              this.$refs.list.getTableData();
            });
          })
          .catch(() => {});
      },
      show() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemShow = { PartsId: this.currentrow.PartsId };
       
      },
    },
  };
  </script>
  
  <style>
  </style>